/*
 * @Author: yangbo04
 * @Date: 2020-05-21 09:52:25
 * @LastEditTime: 2020-05-21 10:04:54
 * @LastEditors: yngbo04
 */
// deeplink
export const deepLink = function (url) {
    window.location.href = `//oper.ppdai.com/act/deeplink/index.html?activityurl=${url}`
}
// 判断是否是微信
export const isWeixin = function () {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/micromessenger/i) == 'micromessenger') {
        return true
    } else {
        return false
    }
}
export const trident = function () {
    const u = navigator.userAgent
    return {
        'iPhone': u.indexOf('iPhone') > -1,
        'android': u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        'isweixin': u.toLowerCase().match(/micromessenger/i) == 'micromessenger'
    }
}
// 获取cookie
export const getCookie = function (name) {
    const arr = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`))
    if (arr != null) {
        return unescape(arr[2])
    } else {
        return null
    }
}
export const getQueryString = function (name) {
    const after = decodeURIComponent(
        window.location.hash.split('?')[1] || window.location.search.split('?')[1]
    )
    if (after) {
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
        const r = after.match(reg)
        if (r != null) {
            return decodeURIComponent(r[2])
        } else {
            return null
        }
    }
}
//  del url query params
export const delURLQueryParams = function (name) {
    const loca = window.location
    const baseUrl = `${loca.origin + loca.pathname}?`
    const query = loca.search.substr(1)
    if (query.indexOf(name) > -1) {
        const obj = {}
        const arr = query.split('&')
        for (let i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split('=')
            // eslint-disable-next-line prefer-destructuring
            obj[arr[i][0]] = arr[i][1]
        }
        delete obj[name]
        const url =
            baseUrl +
            JSON.stringify(obj)
                // eslint-disable-next-line no-useless-escape
                .replace(/[\"\{\}]/g, '')
                // eslint-disable-next-line no-useless-escape
                .replace(/\:/g, '=')
                // eslint-disable-next-line no-useless-escape
                .replace(/\,/g, '&')
        return url
    }
}
// 替换参数
export const replaceURLParamVal = function (url, paramName, replaceWith) {
    // eslint-disable-next-line no-eval
    const re = eval(`/(${paramName}=)([^&]*)/gi`)
    const nUrl = url.replace(re, `${paramName}=${replaceWith}`)
    return nUrl
}
// add params to url
export const addParameterToURL = function (_url, _key, _value) {
    const param = `${_key}=${escape(_value)}`

    let sep = '&'
    if (_url.indexOf('?') < 0) {
        sep = '?'
    } else {
        const lastChar = _url.slice(-1)
        if (lastChar == '&') sep = ''
        if (lastChar == '?') sep = ''
    }
    // eslint-disable-next-line no-param-reassign
    _url += sep + param

    return _url
}
export const goLogin = function () {
    const currentUrl = window.location.href
    if (window.PPDWebUI.os.inApp) {
        const param = {
            'url': currentUrl
        }
        window.PPDWebUI.AccountService.auth(param)
    } else {
        const params = currentUrl
        window.location.href = `https://account.ppdai.com/h5/login?returnUrl=${params}`
    }
}
export const b64DecodeUnicode = function (str) {
    return decodeURIComponent(
        atob(str)
            .split('')
            .map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
            .join('')
    )
}
export const shareParam = function (param) {
    return {
        'wxParam': {
            'linkUrl': param.shareUrl,
            'title': param.shareTitle,
            'desc': param.shareDesc,
            'imgUrl': param.shareImgUrl
        },
        'appParam': {
            'linkURL': param.shareUrl,
            'imgURL': param.shareImgUrl,
            'title': param.shareTitle,
            'desc': param.shareDesc
        }
    }
}
